<template>
  <div class="map-zoom">
      <button class="zoom-in" @click="zoomIn"></button>
      <button class="zoom-out" @click="zoomOut"></button>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ControlsMapZoom',

  computed: {
    ...mapState({
      googleMaps: (state) => state.google.map,
      leafletMaps: (state) => state.leaflet.map,
    }),

    map() {
      return this.googleMaps || this.leafletMaps;
    },
  },

  methods: {
    zoomIn() {
      this.map.setZoom(this.map.getZoom() + 1);
    },

    zoomOut() {
      this.map.setZoom(this.map.getZoom() - 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.map-zoom {
  padding-right: $global-spacing-unit-double;

  button {
    align-items: center;
    background: transparent;
    border: 0;
    cursor: pointer;
    display: flex;
    outline: 0;
    padding: 0;
    text-transform: uppercase;

    &:last-child {
      margin-bottom: 0;
    }

    &::before {
      background-color: $color-white;
      background-position: center center;
      background-repeat: no-repeat;
      border-radius: 50%;
      content: '';
      height: 36px;
      margin-right: $global-spacing-unit-half;
      width: 36px;
    }

    &.zoom-out {
      &::before {
        background-image: url('../../../assets/img/min-blue.svg');
      }

      &:hover::before {
        background-image: url('../../../assets/img/min.svg');
      }
    }

    &.zoom-in {
      margin-bottom: $global-spacing-unit-half;

      &::before {
        background-image: url('../../../assets/img/plus-blue.svg');
      }

      &:hover::before {
        background-image: url('../../../assets/img/plus.svg');
      }
    }

    &:hover::before {
      background-color: $color-cerulean;
    }
  }
}
</style>
